<template>
	<form @submit.prevent="onSubmit">
		<Card>
			<h3>Leaderboards</h3>
			<p>Choose which leaderboards should be shown on the Recycle Race home screen.</p>
			<LeaderboardsForm v-model="value.leaderboards" :ranges="leaderboardRanges" />
		</Card>
		<SaveCancel
			class="submit"
			saveLabel="Update"
			cancelLabel="Reset"
			:hideCancel="!changed"
			:invalid="!changed || invalid"
			:busy="busy"
			@cancel="onCancel"
		/>
	</form>
</template>

<script>
import { LeaderboardRange } from 'recycle-race-common/lib/enums'
import Card from '@/components/Card'
import LeaderboardsForm from '@/forms/LeaderboardsForm'
import SaveCancel from '@/components/SaveCancel'

import { vGlobalEvent } from '@/lib/validators'

export default {
	name: 'GlobalEventForm',
	props: {
		value: Object,
		changed: Boolean,
		busy: Boolean,
	},
	data() {
		return {
			leaderboardRanges: [
				LeaderboardRange.DAILY,
				LeaderboardRange.WEEKLY,
				LeaderboardRange.MONTHLY,
				LeaderboardRange.ALL_TIME,
			],
		}
	},
	computed: {
		invalid() {
			return this.$v.$invalid
		},
	},
	validations: {
		value: vGlobalEvent,
	},
	methods: {
		onSubmit() {
			if (!this.invalid) {
				this.$emit('submit')
			}
		},
		onCancel() {
			this.$emit('reset')
		},
	},
	components: {
		Card,
		SaveCancel,
		LeaderboardsForm,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';

form {
	@include form-spacing;
}

.submit {
	margin-top: 2rem;
}
</style>
